module.exports = __webpack_public_path__ + "static/img/floor3-txt.02047f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor3-txt.png
// module id = n7G6
// module chunks = 1